module.exports = __webpack_public_path__ + "img/flat-lay-ice-cream-frame1.20f719e3.png";